import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-mask-icon',
  templateUrl: './design-mask.component.html'
})
export class DesignMaskComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
